import {ReactComponent as CheckIcon} from './check.svg'

function Check() {
  return <CheckIcon />
}

export default Check
